import React, { useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Button, Modal, ModalFooter } from "react-bootstrap";
import DmsService from "../../../../core/service/DmsService";
import ErrorHandlingService from "../../../../core/service/ErrorHandlingService";

const FolderCreate = ({ t, show, close, parentId = "", item = "" }) => {
  //const [show, setShow] = useState(true);
  //const handleClose = () => setShow(false);
  var data = JSON.parse(localStorage.getItem("authority"));
  const company = data.profile.company.id;
  const [folderName, setFolderName] = useState(item ? item.name : "");
  const handleCreate = (e) => {
   
    e.preventDefault();
    var params = {
      name: folderName,
      directory: true,
      containerId: parentId,
    };
    DmsService.createDocument(params)
      .then((response) => {
        setFolderName("");
        if (response.status === 200 || response.status === 201) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          close();
        }
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
       // var errorRes = error.response;
        // toast.error(error?.response?.data?.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      });
  };
  const handleRename = (e) => {
    e.preventDefault();
    item.name = folderName;
    DmsService.renameDocument(item.id,folderName)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          close(item);
        }
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        var errorRes = error.response;
        if (errorRes.status === 400) {
          close();
        } else {
          toast.error(error.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      });
  }
  return (
    <Modal show={show} onHide={close} keyboard={false} centered>
      <Modal.Header closeButton>
      < Modal.Title as="h5">
          {item ? t("RenameFolder.label") : t("CreateNewFolder.label")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">
          <label className="mb-1">{t("EnterFolderName.label")}</label>
          <input
            type="text"
            className="form-control"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
            required
          />
        </div>
      </Modal.Body>
      <ModalFooter>
        <Button variant="secondary" className="me-2" onClick={close}>
          {t("Close.label")}
        </Button>
        {item ? (
          <Button variant="primary" onClick={handleRename}>
            {t("Rename.label")}
          </Button>
        ) : (
          <Button variant="primary" onClick={handleCreate} className="sbmBtn">
            {t("Create.label")}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};
export default withTranslation()(FolderCreate);
